import axios from 'axios';
import {API} from "@/services/url";

export default {
	createPurchaseOrder : function (data, success, error) {
		axios.post(API.purchaseOrder.create, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getAllPurchaseOrders : function (success, error) {
		axios.get(API.purchaseOrder.all)
			.then(r => success(r.data.purchaseOrderList))
			.catch(e => error(e.response.data.message));
	},
	getPurchaseOrder : function (purchaseOrderId, success, error) {
		axios.get(API.purchaseOrder.all + purchaseOrderId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getAllUndeliveredPurchaseOrders : function (success, error) {
		axios.get(API.purchaseOrder.undelivered)
			.then(r => success(r.data.purchaseOrderList))
			.catch(e => error(e.response.data.message));
	},
	getAllDeliveredPurchaseOrders : function (success, error) {
		axios.get(API.purchaseOrder.delivered)
			.then(r => success(r.data.purchaseOrderList))
			.catch(e => error(e.response.data.message));
	},
	updatePurchaseOrder : function (purchaseOrderId, data, success, error) {
		axios.post(API.purchaseOrder.update + purchaseOrderId, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	exportAsExcel : function (invoiceId, success, error) {
		axios.get(API.purchaseOrder.exportAsExcel, {
			responseType : "blob"
		})
			.then(r => {
				let blob = new Blob([r.data], {
					type: "application/vnd.ms-excel"
				});
				let fileURL = window.URL.createObjectURL(blob);
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'purchase-orders.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			})
			.catch(e => error(e));
	}
}

